import { type ReactElement } from "react";

import { ENV } from "@/features/config";

import { AutoCompleteControl } from "./auto-complete-control";
import { DateFormControl } from "./DateFormControl";
import { DropdownFormControl } from "./DropdownFormControl";
import { EmailFormControl } from "./EmailFormControl";
import { PhoneFormControl } from "./PhoneFormControl";
import { RadioGroupFormControl } from "./RadioGroupFormControl";
import { SearchFormControl } from "./SearchFormControl";
import { TextFormControl } from "./TextFormControl";
import { type FormControlProps } from "./types";

const CLIENT_TYPE_MAP: Record<string, string> = {
  phone: "tel",
};

export class FormControlFactory {
  static createFormControl(props: FormControlProps): ReactElement | null {
    const { field } = props;

    const type = CLIENT_TYPE_MAP[field.client_type!] || field.client_type;

    switch (type) {
      case "email":
        return <EmailFormControl {...props} />;
      case "tel":
        return <PhoneFormControl {...props} />;
      case "search": {
        if (ENV.LOQATE.ENABLED && ENV.LOQATE.KEY) {
          return <SearchFormControl {...props} />;
        }
        return null;
      }
      case "date":
        return <DateFormControl {...props} />;
      case "select":
      case "state":
        return <DropdownFormControl {...props} />;
      case "bank_name":
        return <AutoCompleteControl {...props} />;
      case "radio":
        return <RadioGroupFormControl {...props} />;
      default:
        return <TextFormControl {...props} />;
    }
  }
}
